import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import * as _ from 'lodash';

import { EtablissementModel } from '../../models/EtablissementModel';
import { EtablissementApiService } from '../../web-api-services/etablissement.service';

@Component({
  selector: 'select-etablissement',
  templateUrl: './select-etablissement.component.html',
  styleUrls: ['./select-etablissement.component.css'],
})
export class SelectEtablissementComponent implements OnInit {
  // To detect input change
  private _selectedId: number;
  @Input()
  set selectedId(value: number) {
    this._selectedId = value;
    this.selectEtablissement(this._selectedId);
  }
  get selectedId(): number {
    return this._selectedId;
  }
  @Input()
  etablissementIsLocked: boolean;
  @Output() selectedIdChange: EventEmitter<number> = new EventEmitter<number>();

  etablissements: EtablissementModel[] = [];
  selectedEtablissement: EtablissementModel;

  constructor(private etablissementApiService: EtablissementApiService) {}

  ngOnInit() {
    this.etablissementApiService.getEtablissementsAvecIndicateur().subscribe(a => {
      this.etablissements = a;
      this.selectEtablissement(this._selectedId);
    });
  }

  selectEtablissement(etablissementId: number) {
    if (etablissementId && etablissementId > 0) {
      this.selectedEtablissement = _.find(this.etablissements, e => e.Id == etablissementId);
    } else {
      this.selectedEtablissement = null;
    }
  }

  etablissementChanged() {
    this._selectedId = this.selectedEtablissement ? this.selectedEtablissement.Id : null;
    this.selectedIdChange.emit(this._selectedId);
  }
}
